import {
  Timeframe,
  Compensation,
  ProjectRoles,
  ProjectStages,
  RecentProject,
  UserRole,
  Gender,
  Verification,
  PTestResultsType,
  WebOnboarding,
} from '../user/user.type';

export type OnboardingData = {
  firstName: string;
  lastName: string;
  matchaPoints: number;
  isProfileCompleted: boolean;
  hasVerifiedPhoneNumber: boolean;
  hasCompletedProfileInfo: boolean;
  hasCompletedLookingFor: boolean;
  hasCompletedProfessionalDescriptionPage: boolean;
  hasCompletedPTest: boolean;
  hasSubmittedDocumentsForVerification: boolean;
  profileImageUrl: string;
  phone: string;
  about: string;
  role: UserRole | '';
  gender: Gender | '';
  city: string;
  recentProject: RecentProject;
  skills: string[];
  notableCompanies: string[];
  yearsOfExperience: number;
  isStudent: boolean;
  degrees: string[];
  target_role?: ProjectRoles | undefined;
  project_stage?: ProjectStages | undefined;
  timeframe?: Timeframe | null;
  compensation?: Compensation | null;
  longDescription?: string;
  verification?: Verification;
  personality_results?: PTestResultsType | null;
  webOnboarding?: WebOnboarding;
  continueable: boolean;
};

export type OnboardingErrors = Partial<{
  firstName: string;
  lastName: string;
  profileImageUrl: string;
  phone: string;
  about: string;
  role: string;
  gender: string;
  city: string;
  skills: string;
  notableCompanies: string;
  degrees: string;
  educationForm?: {
    level: boolean;
    title: boolean;
    institution: boolean;
  };
  recentProject: Partial<Record<keyof RecentProject, string>>;
  target_role: string;
  project_stage: string;
  timeframe: string;
  compensation: string;
  longDescription: string;
  linkedInProfileUrl?: string;
  verificationCV?: string;
  verificationCvDescription?: string;
  verificationDocumentDescription?: string;
}>;

export interface City {
  n: string;
  c: string;
};

export type FileType = 'profileImage' | 'projectImage' | 'document';

export interface FileUploadState {
  selectedFile: File | null;
  isUploading: boolean;
  uploadError: string | null;
}

export enum OnboardingStep {
  PhoneNumber = 'phoneNumber',
  PersonalInfo = 'personalInfo',
  RecentProject = 'recentProject',
  Skills = 'skills',
  RolePreferences = 'rolePreferences',
  UploadDocuments = 'uploadDocuments',
  OnboardingCompleted = 'onboardingCompleted',
}
